<template>
  <div class="school-department-report">
    <!--<h3 class="text-xl font-semibold mb-4">School-Department Report</h3>-->
    <div v-if="data.length === 0" class="text-center py-4 text-gray-500">
      No data available for the selected school-department.
    </div>
    
    <div v-else class="overflow-x-auto">
      <ResponseTable :data="data.responseStats" />
      <h4 class="text-lg font-semibold mt-3 mb-3">Question Table</h4>
      <table class="min-w-full divide-y divide-gray-200 border mb-2">
        <tr v-for="(question, idx) in questions" :key="question" class="px-4 py-2 text-left">
          <td class="px-4 py-2 text-left bg-gray-800 text-white" style="font-weight: bold;">Q{{ idx + 1 }}</td>
          <td class="px-4 py-2 text-left">{{ question }}</td>
        </tr>
      </table>
      <table class="min-w-full divide-y divide-gray-200 border">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="px-4 py-2 text-left">School (Responded/Invited)</th>
            <th class="px-4 py-2 text-left">Department (Responded/Invited)</th>
            <th v-for="(question, idx) in questions" :key="question" class="px-4 py-2 text-left">Q{{ idx + 1 }}</th>
            <th class="px-4 py-2 text-left">Average</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(result, index) in sortedschoolDepartmentResultsBySchool"
            :key="`${result.school}-${result.department}`" class="hover:bg-gray-50">
            <template v-if="index === 0 || sortedschoolDepartmentResultsBySchool[index - 1].school !== result.school">
              <td :rowspan="sortedschoolDepartmentResultsBySchool.filter(x => x.school === result.school).length"
                class="px-4 py-2">
                {{ result.school }} ({{ getSchoolResponded(result.school) }}/{{ getSchoolInvited(result.school) }})</td>
            </template>
            <td class="px-4 py-2">{{ result.department }} ({{ result.responded }}/{{ result.invited }})</td>
            <td v-for="question in questions" :key="question" class="px-4 py-2">
              {{ formatRating(result.ratings[question]) }}
            </td>
            <td class="px-4 py-2 font-bold">{{ formatRating(averageRating(result.ratings)) }}</td>
          </tr>
           
            <tr class="bg-gray-100">
              <td colspan="2" class="px-4 py-2 text-left font-bold">University</td>
              <td v-for="question in questions" :key="question" class="px-4 py-2 font-bold">
              {{ formatRating(averageQuestionRating(question)) }}
              </td>
              <td class="px-4 py-2 font-bold">{{ formatRating(averageQuestionRating("Average")) }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ResponseTable from "./ResponseTable.vue";
export default {
  name: 'SchoolDepartmentReport',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components:{
    ResponseTable
  },
  computed: {
   
    sortedschoolDepartmentResultsBySchool() {
      return this.data.schoolDepartmentResults.sort((a, b) => a.school.localeCompare(b.school));
    },
    questions() {
      if (this.data.schoolDepartmentResults.length > 0) {
        return Object.keys(this.data.schoolDepartmentResults[0].ratings);
      }
      return [];
    }
  },
  methods: {
    getSchoolResponded(school) {
      return this.data.schoolDepartmentResults.filter(x => x.school === school).map(x => x.responded).reduce((a, b) => a + b, 0);
    },
    getSchoolInvited(school) {
      return this.data.schoolDepartmentResults.filter(x => x.school === school).map(x => x.invited).reduce((a, b) => a + b, 0);
    },
    formatRating(rating) {
      return rating ? rating == "-" ? "-" : rating.toFixed(2) : '-';
    },
    averageRating(ratings) {
      const validRatings = Object.values(ratings).filter(r => r !== null && r !== undefined);
      return validRatings.length > 0 ? validRatings.reduce((a, b) => a + b, 0) / validRatings.length : '-';
    },
    averageQuestionRating(question) {
      //const ratings = this.data.schoolDepartmentResults.map(result => result.ratings[question]).filter(r => r !== null && r !== undefined);
      const ratings = this.data.avaerageRatings[question]
      return ratings;
    }
  }
}
</script>

<style scoped>
.school-department-report table {
  @apply w-full border-collapse;
}

.school-department-report th,
.school-department-report td {
  @apply border px-4 py-2 text-sm;
}

.school-department-report th {
  @apply font-semibold;
}

.school-department-report tr:hover {
  @apply bg-gray-100;
}
</style>